import { Fragment, useEffect, useState } from "react";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { useParams } from "react-router-dom";
import { PAGES } from "../../../routeConfig";
import { OrderHistory } from "./myorderhistory";
import { ViewOrderDetails } from "./view/viewOrderDetails";
import $ from "jquery";
import { TrackOrderMain } from "../../trackOrder/trackOrderMain";
import { PayOnlineMain } from "../../PayOnline/PayOnlineMain";
import { clearAll as clearOrderHistoryCache } from "./orderHistoryCache";
export const MyOrderHistoryMain = () => {
  const { orderId, page, trackOrderNumber, urlref } = useParams();
  const [breadCrumbs, setBreadCrumb] = useState();
  useEffect(() => {
    if (orderId && page != "Payonline") {
      setBreadCrumb([
        { name: "My Account", url: PAGES.MYACCOUNT },
        { name: "My Order History", url: PAGES.ORDERHISTORY },
        { name: "Order Details", url: "" },
      ]);
    } else {
      setBreadCrumb([
        { name: "My Account", url: PAGES.MYACCOUNT },
        { name: "My Order History", url: PAGES.ORDERHISTORY },
      ]);
    }
    return () => {
      if (!page || page !== "Payonline") {
        clearOrderHistoryCache();
      }
    };
  }, [orderId, page]);
  return (
    <Fragment>
      {page != "Payonline" && <BreadCrumb data={breadCrumbs} />}
      <div className="fz-container">
        <section className={`css-fade fz-panel ${page == "TrackOrder" ? "active" : "inactive"}`}>
          <TrackOrderMain orderRef={orderId} />
        </section>
        <section className={`css-fade fz-panel ${page == "TrackOrder" ? "inactive" : orderId ? "inactive" : "active"}`}>
          <OrderHistory />
        </section>
        <section
          className={`css-fade fz-panel ${page != "TrackOrder" && orderId && page != "Payonline" ? "active" : "inactive"}`}
        >
          <ViewOrderDetails detail={orderId} />
        </section>
        <section className={`css-fade fz-panel ${page == "Payonline" ? "active" : "inactive"}`}>
          <PayOnlineMain orderRef={orderId} />
        </section>
      </div>
    </Fragment>
  );
};
